import moment from 'moment';

export function parseTimeString(timeStr) {
  if (!timeStr || typeof timeStr !== 'string') {
    return 0;
  }

  const match = timeStr.match(/^(\d{1,2}):(\d{2})$/);
  if (!match) {
    return 0;
  }

  const [, hours, minutes] = match.map(Number);
  return hours + minutes / 60;
}

// Assumes lastStatusChangeDate and current time are in same timezone
export function calculateWorkHoursElapsed(lastStatusChangeDate, workWindows, holidays = []) {
  if (!lastStatusChangeDate || !workWindows || workWindows.length === 0) {
    return 0;
  }

  const from = moment(lastStatusChangeDate);
  const to = moment();

  if (!from.isValid() || from.isAfter(to)) {
    return 0;
  }

  const holidaySet = new Set(holidays);

  let totalHours = 0;
  const currentDay = from.clone();

  while (currentDay.isBefore(to)) {
    const dayString = currentDay.format('YYYY-MM-DD');
    const isWeekend = currentDay.day() === 0 || currentDay.day() === 6;
    const isHoliday = holidaySet.has(dayString);

    if (!isWeekend && !isHoliday) {
      const dayStart = currentDay
        .clone()
        .startOf('day');

      const periodStart = currentDay.isSame(from, 'day') ? from : dayStart;

      const periodEnd = currentDay.isSame(to, 'day') ? to : currentDay
        .clone()
        .endOf('day');

      for (const window of workWindows) {
        const windowStart = dayStart
          .clone()
          .hours(Math.floor(window.start))
          .minutes((window.start % 1) * 60);

        const windowEnd = dayStart
          .clone()
          .hours(Math.floor(window.end))
          .minutes((window.end % 1) * 60);

        const effectiveStart = moment.max(periodStart, windowStart);
        const effectiveEnd = moment.min(periodEnd, windowEnd);

        if (effectiveStart.isBefore(effectiveEnd)) {
          totalHours += effectiveEnd
            .diff(effectiveStart, 'hours', true);
        }
      }
    }

    currentDay
      .add(1, 'day')
      .startOf('day');
  }

  return totalHours;
}
